import React from 'react'
import './What.css'
import what1 from '../Images/what1.svg'
import what2 from '../Images/what2.svg'
import what3 from '../Images/what3.svg'
import what4 from '../Images/what4.svg'
import what5 from '../Images/what5.svg'
const What = () => {
    const data = [
        {
            id: 1,
            icon: what1,
            "title": "Custom CRM Development",
            "description": "Custom CRM solutions designed to fit your unique business workflows, providing scalable and adaptable systems for long-term growth."
        },
        {
            id: 2,
            icon: what2,
            "title": "CRM Integration Services",
            "description": "Connect your CRM with ERP, marketing automation, payment gateways, and third-party tools for seamless operations."
        },
        {
            id: 3,
            icon: what3,
            "title": "CRM Migration & Upgrade",
            "description": "Hassle-free migration from legacy systems or upgrading to a more robust CRM without data loss."
        },
        {
            id: 4,
            icon: what4,
            "title": "Mobile CRM Solutions",
            "description": "Enable on-the-go customer management with secure, user-friendly mobile CRM apps."
        },
        {
            id: 5,
            icon: what5,
            "title": "CRM Support & Maintenance",
            "description": "Continuous monitoring, performance optimization, and technical support to keep your CRM running smoothly."
        }
    ]

    return (
        <div id='what'>
            <section className="section">
                <div className="container">
                    <h1 className="heading">
                       End-to-End CRM Solutions for Every Platform
                    </h1>
                    <p className="subHeading">
                       We deliver CRM solutions that do more than manage data—they streamline your workflows, enhance customer engagement, and drive business growth.
                    </p>
                    <div className="wwdSection">
                        {
                            data.map((item) => (
                                <div className="wwdItem">
                                    <div className="wwdIcon">
                                        <img src={item.icon} alt="" />
                                    </div>
                                    <div className="wwdContent">
                                        <h3 className="title">{item.title}</h3>
                                        <p className="subHeading">{item.description}</p>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </section>
        </div>
    )
}

export default What